import React, { Fragment, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { Input, Layer, ListCardInfo } from "../../../components";
import { AppContext } from "../../../components/AppProvider";
import FloatButton from "../../../components/UI/Button/FloatButton";
import {
  PostApi203,
  PostApi255,
  PostApi256,
} from "../../../modules/network/padoPost";
import { IC, ListIcon } from "../../../resources/Assets";
import { ContentBody, HeaderTitle } from "./ReceiptStyle";
import EmptyResult from "../../../components/UI/EmptyResult";
import { LoadingLayer } from "../../common/Layer/Loading";
import ToastMsg from "../../../components/UI/Layer/ToastMsg/ToastMsg";

const ReceiptPharmSearch = props => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);

  const [loading, setLoading] = useState(true);
  const [pharmList, setPharmList] = useState();
  const [pharmInfoTemp, setPharmInfoTemp] = useState(
    props.pharmInfo && props.pharmInfo.phKey != "" ? props.pharmInfo : null
  );

  const [searchPharmName, setSearchPharmName] = useState("");
  const [deleteSearchValue, setDeleteSearchValue] = useState(false);

  const [currentPharmName, setCurrentPharmName] = useState("");
  const [toastView, setToastView] = useState(false);

  const [viewMsgLayer, setViewMsgLayer] = useState(false);
  const [msgType, setMsgType] = useState("selectPharm");

  const messageLayerData = {
    selectPharm: {
      headerIcon: "",
      title: pharmInfoTemp ? pharmInfoTemp.pharmName : "",
      desc: ["이 약국 정보를 선택하시겠습니까?"],
      ps: "",
      button: [
        {
          severity: "light",
          disable: "off",
          small: false,
          clickEvent: () => setViewMsgLayer(false),
          text: "아니오",
        },
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => {
            setViewMsgLayer(false);
            props.buttonClickEvent(pharmInfoTemp);
          },
          text: "네",
        },
      ],
    },
  };

  const getSurroundPharm = () => {
    PostApi255(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          setPharmList(res.resultList);
          setLoading(false);
        }
      })
      .catch(err => {
        setPharmList([]);
        setLoading(false);
      });
  };

  const setMyPharm = (phKey, myph, pharmName) => {
    PostApi203(userinfo, cfg, phonecfg, phKey, myph)
      .then(res => {
        if (res.resultCode === "1" && res.resultMsg === "SUCCESS") {
          getSurroundPharm();
          setCurrentPharmName(pharmName);
          if (myph === "0") {
            setToastView(true);
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const getSearchPharm = () => {
    PostApi256(userinfo, cfg, phonecfg, searchPharmName, "")
      .then(res => {
        if (res.resultCode === "000" && res.resultList.length > 0) {
          setPharmList(res.resultList);
        } else {
          setPharmList([]);
        }
        setLoading(false);
      })
      .catch(err => {
        setPharmList([]);
        setLoading(false);
      });
  };

  const getPharmList = () => {
    if (searchPharmName != "") {
      getSearchPharm();
    } else {
      getSurroundPharm();
    }
  };

  useEffect(() => {
    getSurroundPharm();
  }, []);

  useEffect(() => {
    if (toastView) {
      setTimeout(() => {
        setToastView(false);
      }, 5000);
    }
  }, [toastView]);

  return (
    <Fragment>
      {/* <HeaderTitle style={{ paddingTop: "2px", width: "calc(100% - 32px)" }}> */}
      <HeaderTitle
        style={{
          width: "calc(100% - 32px)",
          borderBottom: "0px",
        }}>
        <div
          style={{ width: "40px", height: "40px" }}
          onClick={props.backClickEvent}>
          <img src={IC.etc.ICON_CHEVRON_LEFT} />
        </div>
        <Input
          title_view={false}
          input_text_style={{
            background: "#f5f5f5",
            border: "1px #f5f5f5 solid",
          }}
          input_view={false}
          input_type="text"
          input_pattern=""
          input_disable={false}
          input_placeholder="약국명을 입력하세요"
          input_defaultValue={searchPharmName}
          input_onChange={e => {
            setSearchPharmName(e.target.value);
            setDeleteSearchValue(false);
          }}
          input_rIconView={true}
          input_rIcon={
            deleteSearchValue === false
              ? ListIcon.RECEIPT.R_ICON.SEARCH
              : // : IC.etc.ICON_X_CIRCLE
                IC.close.ICON_CLOSE_X
          }
          input_rIconEvent={() => {
            if (deleteSearchValue === false) {
              setLoading(true);
              getPharmList();
              setDeleteSearchValue(true);
            } else {
              // setLoading(true);
              setSearchPharmName("");
              setDeleteSearchValue(false);
            }
          }}
          button_style={{ width: "14px" }}
          button_view={false}
          enterEvent={e => {
            if (window.event.keyCode == 13) {
              setLoading(true);
              getPharmList();
              setDeleteSearchValue(true);
            }
          }}
        />
      </HeaderTitle>

      <ContentBody
        style={{
          height: "calc(100vh - 185px)",
          overflowY: "auto",
          overflowX: "hidden",
          gap: "8px",
          paddingTop: "20px",
        }}>
        {loading ? (
          <LoadingLayer />
        ) : pharmList.length > 0 ? (
          pharmList.map((item, i) => (
            <ListCardInfo
              key={"ListCardInfo" + i}
              status={
                pharmInfoTemp && pharmInfoTemp.phKey === item.pharmacy[0].phKey
                  ? "active"
                  : "default"
              }
              bodyInfoHeader={
                item.pharmacy[0].phName + "(" + item.pharmacy[0].address2 + ")"
              }
              bodyInfoBody={[
                {
                  left: (
                    <TextDiv
                      color="#666"
                      fontWeight="500"
                      style={{ flex: "none" }}>
                      {item.pharmacy[0].distance}
                    </TextDiv>
                  ),
                  right: (
                    <TextDiv color="#888" fontWeight="400">
                      {item.pharmacy[0].address3}
                    </TextDiv>
                  ),
                },

                {
                  left: (
                    <TextDiv color="#888" fontWeight="400">
                      {item.pharmacy[0].phone}
                    </TextDiv>
                  ),
                  right: "",
                },
              ]}
              bodyInfoBodyAction={() => {
                setPharmInfoTemp({
                  phKey: item.pharmacy[0].phKey,
                  pharmFaxNum: item.pharmacy[0].faxNum.replaceAll("-", ""),
                  pharmTelNo: item.pharmacy[0].phone.replaceAll("-", ""),
                  pharmName:
                    item.pharmacy[0].phName +
                    "(" +
                    item.pharmacy[0].address2 +
                    ")",
                });

                // 메세지 레이어 창 출력
                setViewMsgLayer(true);
              }}
              bodyInfoBottom={""}
              bodyIcon={[
                {
                  icon:
                    item.pharmacy[0].myph === "0"
                      ? ListIcon.RECEIPT.R_ICON.HEART_GRAY
                      : ListIcon.RECEIPT.R_ICON.HEART_PURPLE,
                  action: () =>
                    setMyPharm(
                      item.pharmacy[0].phKey,
                      item.pharmacy[0].myph,
                      item.pharmacy[0].phName
                    ),
                },
                {
                  icon: "",
                  action: () => console.log("TEST"),
                },
                {
                  icon: "",
                  action: () => console.log("TEST"),
                },
              ]}
            />
          ))
        ) : (
          <EmptyResult
            icon={IC.empty.nearByPh}
            text={"검색된 약국이 없습니다."}
          />
        )}

        {/* <FloatButton
          severity="primary"
          disable="off"
          event={() => {
            props.buttonClickEvent(pharmInfoTemp);
          }}
          text="저장 후 다음"
        /> */}
      </ContentBody>

      {viewMsgLayer && (
        <Layer
          headerIcon={messageLayerData[msgType].headerIcon}
          title={messageLayerData[msgType].title}
          desc={messageLayerData[msgType].desc}
          ps={messageLayerData[msgType].ps}
          button={messageLayerData[msgType].button}
        />
      )}

      {toastView && (
        <div style={{ marginLeft: "20px" }}>
          <ToastMsg
            option={{
              img: IC.check.ICON_GREEN_CHECK,
              // bottom: "102px",
              bottom: "14px",
              text: currentPharmName + "이 즐겨찾기에 추가되었습니다",
            }}
          />
        </div>
      )}
    </Fragment>
  );
};

const TextDiv = styled.div`
  color: ${props => props.color};

  /* Body/3/Regular */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: ${props => props.fontWeight};
  line-height: 16px; /* 133.333% */
  letter-spacing: -0.24px;
`;

export default ReceiptPharmSearch;
